import React from 'react'
import {FaInfoCircle} from 'react-icons/fa'
import Notice from '@components/V3/Notice'
import {useContactModalContext} from '@page-components/TrackV2/components/ContactModalContext'
import useStatus from '@page-components/TrackV2/hooks/useStatus'
import {useTranslation} from 'next-i18next'

export default function IssuesWithOrder() {
  const status = useStatus()
  const {setOpen} = useContactModalContext()
  const {t} = useTranslation('tracking', {keyPrefix: 'issuesWithOrder'})
  if (status !== 'done') return null

  return (
    <div>
      <Notice level="info" className="!rounded-lg">
        <div className="flex space-x-4 items-center">
          <FaInfoCircle size={18} />
          <div className="flex-1">
            <p>{t('hadAnyProblems')}</p>
            <a onClick={() => setOpen(true)} className="underline text-blue-700">
              {t('weCanHelpYou')}
            </a>
          </div>
        </div>
      </Notice>
    </div>
  )
}
